<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-table-simple small>
      <b-thead class="columnas">
        <b-tr>
          <b-th>Producto</b-th>
          <b-th>Cantidad Orden</b-th>
          <b-th>Cantidad autorizada</b-th>
          <b-th>Precio unitario</b-th>
          <b-th>Sub total</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(lista, index) in producto" :key="index">
          <b-td>{{ lista.descripcion }}</b-td>
          <b-td>{{ lista.cantidad }} </b-td>
          <b-td>{{ lista.cantidadAutorizada }}</b-td>
          <b-td>{{ lista.precio | moneda }}</b-td>
          <b-td>{{ lista.monto | moneda }}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: "DetalleOrdinario",
  props: {
    producto: Array,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>